import { cacheExchange, createClient, dedupExchange } from 'urql';

import { multipartFetchExchange } from '@urql/exchange-multipart-fetch';
import { API_URL } from '~src/config';

export const createGraphQLClient = () =>
  createClient({
    url: getBackendURI(),
    maskTypename: true,
    exchanges: [dedupExchange, cacheExchange, multipartFetchExchange],
  });

const getBackendURI = (path = 'graphql/v1') => `${API_URL}/${path}`;
